import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { SystemService } from '../../../services/system.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { PrintService } from '../../../services/print.service'
import { ClaudeService } from '../../../services/claude-service.service';
import { ClaudeResponseParser } from '../../../services/claude-response-parser.service';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-customer-web-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.scss'],
  // The AI report markup arrives as an HTML string and is rendered via
  // [innerHtml], which bypasses Angular's template compiler entirely — those
  // nodes never receive the `_ngcontent-*` attribute Angular's default
  // (Emulated) encapsulation relies on to scope styles, so component-scoped
  // rules can never reach them. Encapsulation is disabled here so the
  // `.ai-results`-scoped styles in customer-search.component.scss actually
  // apply; every rule in that file is nested under `.ai-results` so it still
  // can't leak onto the rest of this component's own template (the search
  // form, results table, etc.) or the rest of the app.
  encapsulation: ViewEncapsulation.None
})
export class CustomerWebSearchComponent implements OnInit {
	searchresults: any = [];
	searchForm: UntypedFormGroup;
	searching: any = false;
	generating: any = false;
	@ViewChild('print_table') printtable: ElementRef;
	filename = 'Customer_WebSearch_Report';
	aiLoading = false;
	aiText: any = '';
	aiError: any = '';
	private aiRequestSub: Subscription | null = null;
	
	constructor(
		private fb: UntypedFormBuilder,
		public systemService: SystemService,
		public globalSearchService: GlobalSearchService,
		public printService: PrintService,
		private claudeService: ClaudeService,
		private claudeResponseParser: ClaudeResponseParser
	) {}
	
	ngOnInit(): void {
		
		this.searchForm = this.fb.group({
				onlyzero: ['0'],
				ip: [''],
				keywords: [''],
				name: [''],
				startdate: [''],
				enddate: [''],
				limit: ['100'],
		});
		this.searchsearch();
	}
	
	searchsearch(){
		this.searching = true;
		const data = this.searchForm.value;
		this.systemService.getCustomerSearches(data).subscribe(r => {
			this.searching = false;
			this.searchresults = r;
		});
	}
	
		exportPdf() {
		this.generating = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Customer Search Report',
			subtitle: 'Run on ' + today.toLocaleString()
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.generating = false;
		});
	}

	exportXls() {
		this.generating = true;
		const today = new Date();
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);

		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Customer Search Report',
			subtitle: 'Run on ' + today.toLocaleString()
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.generating = false;
		});
	}
	
	runAiReport(): void {
		if (this.aiLoading) return;
		this.aiRequestSub?.unsubscribe();
		this.aiLoading = true;
		this.aiError = '';
		this.aiText = '';
		this.systemService.getAICustomerSearches().subscribe(r => {
			const reportPayload = r;
				this.aiRequestSub = this.systemService.getSearchAnalysis(reportPayload).pipe(
			finalize(() => {
				this.aiLoading = false;
			})
		).subscribe({
			next: (res: any) => {
				try {
					this.aiText = res.aiText || '';
				} catch (e: any) {
					this.aiError = e?.message || 'Could not read AI response.';
				}
			},
			error: (err: any) => {
				this.aiError = err?.error?.error?.message || err?.message || 'AI request failed.';
			}
		});
		});
	

	
	}
}
